import styles from "./NotFound.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import PushButton from "../../UI/Buttons/PushButton/PushButton";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const attemptedPath = location.pathname || "/";

  const goHome = () => {
    navigate("/");
  };

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate("/");
  };

  return (
    <div id="not-found-page" className={styles["not-found-container"]}>
      <div
        id="not-found-modal"
        className={styles["modal"]}
        role="dialog"
        aria-modal="true"
        aria-labelledby="not-found-title"
        aria-describedby="not-found-description"
      >
        <div className={styles["panel"]}>
          <div className={styles["panel-glow"]} aria-hidden="true" />

          <p className={styles["status-code"]} aria-hidden="true">
            404
          </p>

          <div className={styles["content"]}>
            <p className={styles["eyebrow"]}>Ignite Elysium</p>
            <h1 id="not-found-title" className={styles["title"]}>
              Page Not Found
            </h1>
            <p id="not-found-description" className={styles["lead"]}>
              That route is off the map. It may have been moved, renamed, or
              never existed.
            </p>
            <p className={styles["path-line"]}>
              <span className={styles["path-label"]}>Requested path</span>
              <code className={styles["path-value"]}>{attemptedPath}</code>
            </p>
          </div>

          <div className={styles["actions"]}>
            <PushButton
              inputOrButton="button"
              colorType="primary"
              size="body"
              onClick={goHome}
              styles={{
                margin: 0,
                minWidth: "9em",
                borderRadius: "50px",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                fontSize: "1.35rem",
                padding: "0.55em 1.25em",
              }}
            >
              Return Home
            </PushButton>
            <PushButton
              inputOrButton="button"
              colorType="secondary"
              size="body"
              onClick={goBack}
              styles={{
                margin: 0,
                minWidth: "9em",
                borderRadius: "50px",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                fontSize: "1.35rem",
                padding: "0.55em 1.25em",
              }}
            >
              Go Back
            </PushButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
